import { useState, useEffect } from 'react';
import './ColorTool.less';
import { RgbaColorPicker } from 'react-colorful';
import Icon from '@/components/iconfont/Icon';
import EyedropperSVG from '@/assets/colortool/eyedropper.svg';

// 将这些工具函数移到组件外部
const rgbToHex = ({ r, g, b }) => {
  const toHex = (n) => {
    const hex = n.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const hexToRgb = (hex = '#f71111') => {
  hex = hex.replace('#', '');
  const bigint = parseInt(hex, 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
};

export default function ColorTool({
  colorValue, // 带#的十六进制色值
  opacityValue, // 透明度值 1-100
  onColorChange, // 颜色变化回调
  setOpacity, // 透明度回调
  onShow,
}) {
  const Torgba = () => {
    return {
      ...hexToRgb(colorValue),
      a: opacityValue / 100,
    };
  };
  // 将输入的hex转换为rgb对象，并将透明度转换为0-1
  const [color, setColor] = useState(Torgba());
  const [modeType, setModeType] = useState('RGB');

  useEffect(() => {
    setColor(Torgba());
  }, [colorValue, opacityValue]);
  const [dropShow, setDropShow] = useState(false);
  // 处理颜色变化
  const handleColorChange = (newColor) => {
    console.log(newColor);

    setColor(newColor);
  };

  // 修改吸色功能
  const handleEyeDropper = async () => {
    if (window.EyeDropper) {
      const eyeDropper = new window.EyeDropper();
      try {
        const result = await eyeDropper.open();
        const rgbColor = hexToRgb(result.sRGBHex);
        handleColorChange({ ...rgbColor, a: opacityValue / 100 });
        handleStopChange({ ...rgbColor, a: opacityValue / 100 });
      } catch (err) {
        console.log(err);
      }
    } else {
      console.log('吸色不可用');
    }
  };

  // 修改RGB输入处理
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = Math.max(0, Math.min(255, parseInt(value, 10) || 0));
    const newColor = { ...color, [name]: updatedValue };
    handleColorChange(newColor);
  };
  const handleChangeOpacity = (e) => {
    const alpha = Math.max(0, Math.min(100, parseInt(e.target.value, 10) || 0));
    // setOpacity(alpha);
    setColor((prev) => ({ ...prev, a: alpha / 100 }));
  };

  // 修改HEX输入处理
  const handleHexChange = (e) => {
    const hex = e.target.value;
    if (/^#?[0-9A-Fa-f]{6}$/.test(hex)) {
      const rgbColor = hexToRgb(hex);
      handleColorChange({ ...rgbColor, a: opacityValue / 100 });
    }
  };
  // 全局点击事件监听
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.tagName.toLowerCase() === 'a') {
        return;
      }
      // 检查点击事件是否发生在dropdown元素之外
      if (!event.target.closest('.select_box')) {
        // setDropShow(false);
        setDropShow(false);
      }
      if (!event.target.closest('.color_tool_box') && !event.target.closest('.select_color_btn')) {
        onShow(false);
      }
    };

    // 添加事件监听
    document.addEventListener('mousedown', handleClickOutside);

    // 清理事件监听
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // 修改停止变化的处理函数
  const handleStopChange = () => {
    const hexColor = rgbToHex(color);
    const opacity = Math.round(color.a * 100);
    // 只在颜色值真正发生变化时触发回调
    if (hexColor !== colorValue) {
      onColorChange(hexColor);
    }

    // 只在透明度真正发生变化时触发回调
    if (opacity !== opacityValue) {
      setOpacity(opacity);
    }
  };

  const handleSelectMode = (val) => {
    setModeType(val);
    setDropShow(false);
  };
  useEffect(() => {
    const handleMouseUp = () => {
      handleStopChange();
    };
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [color]);
  return (
    <div className="color_tool_box">
      <RgbaColorPicker
        className="color_tool"
        color={color}
        onChange={handleColorChange}
        // onMouseUp={handleStopChange}
      />
      <div className="option_box">
        <div className="option_left">
          <div className="dropdown dropdown-open">
            <div
              tabIndex={0}
              role="button"
              className="select_box"
              onClick={() => {
                setDropShow(!dropShow);
              }}>
              {modeType}
              <Icon name="icon-arrow-down" className="icon_down" />
            </div>
            {dropShow && (
              <ul
                tabIndex={0}
                className="dropdown-content menu bg-base-100 rounded-box z-[1] shadow">
                <li
                  onClick={() => {
                    handleSelectMode('RGB');
                  }}>
                  <a>RGB</a>
                </li>
                <li
                  onClick={() => {
                    handleSelectMode('HEX');
                  }}>
                  <a>HEX</a>
                </li>
              </ul>
            )}
          </div>
          {modeType === 'RGB' ? (
            <>
              <div className="color_value">
                <input
                  type="number"
                  id="r"
                  name="r"
                  value={color.r}
                  onChange={handleInputChange}
                  onBlur={handleStopChange}
                />
              </div>
              <div className="color_value">
                <input
                  type="number"
                  id="g"
                  name="g"
                  value={color.g}
                  onChange={handleInputChange}
                  onBlur={handleStopChange}
                />
              </div>
              <div className="color_value">
                <input
                  type="number"
                  id="b"
                  name="b"
                  value={color.b}
                  onChange={handleInputChange}
                  onBlur={handleStopChange}
                />
              </div>
            </>
          ) : (
            <>
              <input
                className="color_hex"
                id="hex"
                type="text"
                value={rgbToHex(color)}
                onChange={handleHexChange}
              />
            </>
          )}
          <div className="color_opacity">
            <input
              type="number"
              id="opacity"
              name="opacity"
              value={Math.round(color.a * 100)}
              onChange={handleChangeOpacity}
              onBlur={handleStopChange}
            />
            <span
              style={{
                position: 'absolute',
                right: '4px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                userSelect: 'none',
                color: 'inherit',
              }}>
              %
            </span>
          </div>
        </div>
        <div className="eyeDropper_box" onClick={handleEyeDropper}>
          <img src={EyedropperSVG} alt="" />
        </div>
      </div>
    </div>
  );
}
